module.exports = tribe.common.data;